import type { ChakraStylesConfig, GroupBase } from 'chakra-react-select';
import { AutocompleteItem } from '@habity/types/autocomplete';

export const autocompleteStyles: ChakraStylesConfig<
  AutocompleteItem,
  true,
  GroupBase<AutocompleteItem>
> = {
  clearIndicator: (provided) => ({
    ...provided,
    fontSize: 'xs',
    mr: 1,
  }),
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: 'blackAlpha.100',
    borderColor: 'transparent',
    borderRadius: '4px',
    h: '48px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    p: 0,
    display: 'none',
  }),
  downChevron: (provided) => ({
    ...provided,
  }),
  crossIcon: (provided) => ({
    ...provided,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
  }),
  input: (provided) => ({
    ...provided,
    fontWeight: 'medium',
    letterSpacing: 'tight',
    borderRadius: 'md',
    minWidth: 6,
  }),
  inputContainer: (provided) => ({
    ...provided,
  }),
  group: (provided) => ({
    ...provided,
    my: '1',
    color: 'blackAlpha.800',
  }),
  groupHeading: (provided) => ({
    ...provided,
    paddingTop: '2',
    paddingLeft: '4',
    paddingBottom: '0',
    fontSize: 'sm',
    fontWeight: 'light',
    color: 'blackAlpha.700',
  }),
  loadingIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  loadingMessage: (provided) => ({
    ...provided,
  }),
  menu: (provided) => ({
    ...provided,
    border: '0',
    zIndex: 'overlay',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0',
    paddingBottom: '0',
    color: 'blackAlpha.700',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'blackAlpha.800',
    color: 'white',
    flexShrink: '0',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
    fontWeight: 'normal',
    flexShrink: '0',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: 'sm',
    fontWeight: 'normal',
    margin: '0',
    py: '1',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'blackAlpha.600',
    fontWeight: 'medium',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  }),
  singleValue: (provided) => ({
    ...provided,
  }),
  valueContainer: (provided) => ({
    ...provided,
    paddingLeft: '3rem',
    maxW: 'calc(100vw - 100px)', // Leave room for 2 buttons on the side
    flexWrap: 'nowrap',
  }),
};

export const claimInputStyles: typeof autocompleteStyles = {
  // Copy base
  ...autocompleteStyles,

  // Redefine
  clearIndicator: (provided) => ({
    ...provided,
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '16px', // Prevent zoom on mobile Chrome
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '16px', // Prevent zoom on mobile Chrome
  }),
  option: (provided) => ({
    ...provided,
    paddingLeft: 0,
    paddingRight: 0,
  }),
  loadingMessage: (provided) => ({
    ...provided,
    paddingLeft: 0,
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    paddingLeft: 0,
  }),
};
